<template>
  <div>
    <div id="arts" ref="arts">
      <navigator-work
        label="Archivo | Archive"
        section="Archivo"
        previous_section="Home"
        previous_url="/"
      />
      <div id="photos-arts">
        <vue-load-image
          v-for="(work, index) in arts"
          :key="work.pk"
          class="image-container"
        >
          <div
            slot="preloader"
            class="skeleton-loader"
            :style="{ animationDelay: index * 0.15 + 's' }"
          ></div>
          <img
            slot="image"
            class="image-gallery-arts"
            :src="resolve_img_server(work.cover)"
            alt="index"
            @click="showGallery(work)"
          />
        </vue-load-image>
      </div>
    </div>
    <div v-if="image.visible" id="gallery-arts">
      <div id="background-gallery-arts" />
      <div id="navigation-left" @click="leftImage" class="navigation-button">
        <img src="@/assets/works/cursor-izq.png" height="40px" alt="Previous" />
      </div>
      <div id="navigation-right" @click="rightImage" class="navigation-button">
        <img src="@/assets/works/cursor-der.png" height="40px" alt="Next" />
      </div>
      <div
        id="image-arts"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
      >
        <div v-if="image.id_video">
          <img
            v-if="!vimeo_ready"
            alt="Cargando..."
            src="@/assets/gallery/loading.png"
            height="35px"
          />
          <vue-vimeo-player
            :video-id="image.id_video"
            player-height="640px"
            @ready="onVimeoReady"
          />
        </div>
        <vue-load-image v-else>
          <img
            slot="preloader"
            alt="Cargando..."
            src="@/assets/gallery/loading.png"
            height="35px"
          />
          <img
            slot="image"
            id="center-image-arts"
            :src="resolve_img_server(image.path)"
            :alt="image.description"
          />
        </vue-load-image>
      </div>
      <div id="gallery-info-container-arts-cellphone">
        <div id="container-gallery-counter-arts">
          <img
            :src="this.resolve_img_url('cursor-izq.png')"
            height="17px"
            @click="leftImage"
            class="left-image-clicker"
          />
          <div id="gallery-counter-arts">
            <img
              v-for="i in quantity_images"
              class="circle-image"
              :src="getCircle(i)"
              :key="i"
              height="17px"
              alt=""
              @click="go_to_image(i)"
            />
          </div>
          <img
            :src="this.resolve_img_url('cursor-der.png')"
            height="17px"
            @click="rightImage"
            class="right-image-clicker"
          />
        </div>
        <div id="gallery-text-arts">{{ image.title }}</div>
        <div id="text-description-arts">
          <vue-marked>
            {{ actual_work.description }}
            {{ image.extra_description }}
          </vue-marked>
        </div>
      </div>
      <div id="gallery-info-container-arts">
        <div id="gallery-counter-arts">
          <img
            v-for="i in quantity_images"
            class="circle-image"
            :src="getCircle(i)"
            :key="i"
            height="17px"
            alt=""
            @click="go_to_image(i)"
          />
        </div>
        <div id="gallery-text-arts">{{ image.title }}</div>
        <div id="gallery-info-arts" @click="showDescription">
          <a href="#">info</a>
        </div>
      </div>
      <div
        id="gallery-description-arts"
        v-show="show_description"
        @mousemove="restoreMouse"
      >
        <div id="close-description-arts" @click="closeDescription">
          <img
            class="close-description-image"
            alt="Cerrar"
            src="@/assets/gallery/cruz_info.png"
            height="30px"
          />
        </div>
        <div id="text-description-arts">
          <vue-marked>
            {{ actual_work.description }}
            {{ image.extra_description }}
          </vue-marked>
        </div>
      </div>
      <div id="close_image-arts" @click="hideGallery" @mousemove="restoreMouse">
        <img alt="Cerrar" src="@/assets/gallery/cruz.png" height="30px" />
      </div>
    </div>
  </div>
</template>

<script>
import NavigatorWork from "@/components/NavigatorWork.vue";
import { vueVimeoPlayer } from "vue-vimeo-player";
import VueLoadImage from "vue-load-image";
import VueMarked from "vue-marked";
import axios from "axios";

export default {
  name: "arts",
  components: { NavigatorWork, vueVimeoPlayer, VueLoadImage, VueMarked },
  data: function () {
    return {
      arts: [],
      carousel: [],
      image: {
        visible: false,
        path: "",
        title: "",
        description: "",
        id_video: "",
      },
      actual_work: "",
      actual_image_index: 0,
      quantity_images: 0,
      location_cursor: "",
      show_description: false,
      vimeo_ready: false,
      touchStartX: 0,
      touchEndX: 0,
    };
  },
  methods: {
    handleTouchStart(event) {
      this.touchStartX = event.changedTouches[0].screenX;
    },
    handleTouchMove(event) {
      this.touchEndX = event.changedTouches[0].screenX;
    },
    handleTouchEnd() {
      const swipeThreshold = 50;
      const diff = this.touchStartX - this.touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next image
          this.rightImage();
        } else {
          // Swipe right - previous image
          this.leftImage();
        }
      }
    },
    getWorks: async function () {
      try {
        axios
          .get("https://api.ladraaaaa.com/api/art/")
          .then((response) => (this.arts = response.data));
      } catch (error) {
        console.log(error);
      }
    },
    getWorkItems: async function (id_work) {
      try {
        axios
          .get("https://api.ladraaaaa.com/api/art/items/" + id_work)
          .then((response) => (this.carousel = response.data));
      } catch (error) {
        console.log(error);
      }
    },
    keyup: function (event) {
      const actions = {
        Escape: () => this.hideGallery(),
        ArrowLeft: () => this.leftImage(),
        ArrowRight: () => this.rightImage(),
      };
      const action = actions[event.key];
      if (action) {
        event.preventDefault();
        action();
      }
    },
    showGallery: async function (work) {
      try {
        axios
          .get("https://api.ladraaaaa.com/api/art/items/" + work.pk)
          .then((response) => {
            this.actual_work = work;
            this.carousel = response.data;
            this.image.title = work.title;
            this.image.path = response.data[0].image;
            this.image.extra_description = response.data[0].extra_description;
            this.quantity_images = this.carousel.length;
            this.image.visible = true;
            window.addEventListener("keyup", this.keyup);
          });
      } catch (error) {
        console.log(error);
      }
    },
    hideGallery: function () {
      this.image.visible = false;
      this.show_description = false;
      this.actual_image_index = 0;
      this.carousel.shift();
      this.restoreMouse();
      window.removeEventListener("keyup", this.keyup);
    },
    leftImage: function () {
      let quantity_images = this.carousel.length;
      if (this.actual_image_index === 0) {
        this.actual_image_index = quantity_images - 1;
      } else {
        this.actual_image_index = this.actual_image_index - 1;
      }
      this.image.description = this.actual_work.description;
      this.image.description += "\n";
      this.image.extra_description =
        this.carousel[this.actual_image_index].extra_description;
      this.image.path = this.carousel[this.actual_image_index].image;
      this.image.id_video = this.carousel[this.actual_image_index].id_video;
    },
    rightImage: function () {
      let quantity_images = this.carousel.length;
      if (this.actual_image_index === quantity_images - 1) {
        this.actual_image_index = 0;
      } else {
        this.actual_image_index = this.actual_image_index + 1;
      }
      this.image.extra_description =
        this.carousel[this.actual_image_index].extra_description;
      this.image.path = this.carousel[this.actual_image_index].image;
      this.image.id_video = this.carousel[this.actual_image_index].id_video;
    },
    go_to_image: function (i) {
      this.actual_image_index = i - 1;
      this.image.extra_description =
        this.carousel[this.actual_image_index].extra_description;
      this.image.path = this.carousel[this.actual_image_index].image;
      this.image.id_video = this.carousel[this.actual_image_index].id_video;
    },
    restoreMouse: function () {
      document.body.style.cursor = "default";
      this.location_cursor = "";
    },
    onVimeoReady() {
      this.vimeo_ready = true;
    },
    showDescription: function () {
      this.show_description = true;
    },
    closeDescription: function () {
      this.show_description = false;
    },
    updateInfoLinks: function () {
      this.$nextTick(() => {
        const containers = document.querySelectorAll(
          "#gallery-arts #text-description-arts"
        );
        containers.forEach((container) => {
          const links = container.querySelectorAll("a[href]");
          links.forEach((link) => {
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "noopener noreferrer");
          });
        });
      });
    },
    getCircle: function (i) {
      i = i - 1;
      let images = require.context(
        "../assets/gallery/",
        false,
        /\.png$|\.jpg$|\.gif/
      );
      if (i === this.actual_image_index) {
        return images(`./${"circulo_relleno.png"}`);
      } else {
        return images(`./${"circulo.png"}`);
      }
    },
    resolve_img_server: function (path) {
      const url = "https://api.ladraaaaa.com/" + path;
      // TODO: REMOVE THIS DELAY - Only for testing skeleton loader
      // return url + "?delay=" + Math.random();
      return url;
    },
    resolve_img_url: function (path) {
      if (path === "") {
        return "";
      }
      let images = require.context(
        "../assets/works/",
        false,
        /\.png$|\.jpg$|\.gif/
      );
      return images(`./${path}`);
    },
  },
  watch: {
    show_description(newVal) {
      if (newVal && this.image.visible) {
        this.updateInfoLinks();
      }
    },
    "image.description"() {
      if (this.show_description && this.image.visible) {
        this.updateInfoLinks();
      }
    },
    "actual_work.description"() {
      if (this.show_description && this.image.visible) {
        this.updateInfoLinks();
      }
    },
  },
  created() {
    this.getWorks();
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Paprika&display=swap");

body {
  background: #000000;
  margin-top: 66px;
  margin-left: 33px;
  overflow-y: scroll;
  font-family: "Paprika", regular, serif;
}

a {
  color: #03ff00;
}
#background-gallery-arts {
  background: rgba(0, 0, 0, 0.85);
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  position: fixed;
}
#center-image-arts {
  max-height: 640px;
}
#image-arts {
  z-index: 99;
  position: fixed;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
#gallery-text-arts {
  z-index: 99;
  color: #03ff00;
  font-size: 18px;
  font-family: "Paprika", regular, serif;
}

#gallery-info-arts {
  font-size: 18px;
}

#gallery-description-arts {
  z-index: 120;
  position: fixed;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 24px;
  font-family: "Paprika", regular, serif;
  color: black;
  height: 500px;
  width: 1050px;
  text-align: justify;
}

#text-description-arts {
  height: 100%;
  overflow-y: scroll;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
}

#gallery-info-container-arts {
  z-index: 120;
  color: #03ff00;
  font-size: 17px;
  font-family: "Paprika", regular, serif;
  bottom: 40px;
  left: 50%;
  position: fixed;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: space-between;
  width: 600px;
}

#photos-arts {
  padding-top: 100px;
  margin-left: 43px;
  margin-right: 43px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px 20px;
  justify-items: center;
  align-items: stretch;
}

.image-container {
  width: 100%;
  min-width: 350px;
  display: block;
}

.image-gallery-arts {
  width: 100%;
  height: auto;
  aspect-ratio: 4/3;
  object-fit: cover;
  margin: 0;
  cursor: pointer;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
  display: block;
}
.image-gallery-arts:hover {
  transform: scale(1.03);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
}

.skeleton-loader {
  width: 100%;
  aspect-ratio: 4/3;
  background: #3a3a3a;
  border-radius: 8px;
  animation: pulse 1s ease-in-out infinite;
  display: block;
}

@keyframes pulse {
  0%,
  100% {
    background-color: #3a3a3a;
  }
  50% {
    background-color: #4a4a4a;
  }
}

.navigation-button {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  z-index: 101;
  cursor: pointer;
  padding: 20px;
  transition: opacity 0.2s;
  opacity: 0.7;
}

.navigation-button:hover {
  opacity: 1;
}

#navigation-left {
  left: 20px;
}

#navigation-right {
  right: 20px;
}

#close_image-arts {
  cursor: pointer;
  z-index: 100;
  position: fixed;
  top: 3%;
  right: 3%;
}

.close-description-image {
  cursor: pointer;
}

#close-description-arts {
  text-align: start;
}

#gallery-counter-arts {
  align-self: center;
  margin-top: 3px;
}
.circle-image {
  cursor: pointer;
}

#gallery-info-container-arts-cellphone {
  display: none;
}

@media only screen and (max-width: 1024px) {
  .navigation-button {
    display: none;
  }

  body {
    margin-top: 20px;
    margin-left: 10px;
    margin-right: 10px;
  }

  #photos-arts {
    padding-top: 60px;
    margin-left: 8px;
    margin-right: 8px;
    gap: 20px 15px;
  }

  .image-container {
    min-width: 300px;
  }

  #image-arts {
    z-index: 99;
    position: fixed;
    left: 50%;
    top: 55%;
    -webkit-transform: translate(-50%, -100%);
    transform: translate(-50%, -100%);
  }

  #center-image-arts {
    max-width: 950px;
    max-height: 380px;
  }

  #gallery-info-container-arts {
    display: none;
  }

  #gallery-info-container-arts-cellphone {
    z-index: 120;
    color: #03ff00;
    font-size: 17px;
    font-family: "Paprika", regular, serif;
    top: 60%;
    left: 50%;
    position: fixed;
    display: flex;
    flex-direction: column;
    transform: translateX(-50%);
    align-items: center;
  }

  #text-description-arts {
    font-size: 14px;
    height: 100%;
    overflow-y: auto;
    padding: 10px;
    border-radius: 6px;
  }
  iframe {
    max-width: 950px;
    max-height: 370px;
  }

  #container-gallery-counter-arts {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-self: center;
    padding-left: 10px;
    padding-right: 10px;
  }

  .left-image-clicker {
    margin-top: 5px;
    margin-right: 10px;
    cursor: pointer;
  }
  .right-image-clicker {
    margin-top: 5px;
    margin-left: 10px;
    cursor: pointer;
  }

  #gallery-description-arts {
    width: 90vw;
    max-width: 500px;
    height: 50vh;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    z-index: 120;
    border-radius: 8px;
    overflow-y: auto;
  }
}

@media only screen and (max-width: 768px) {
  #center-image-arts,
  iframe {
    max-width: 98vw;
    max-height: 45vh;
  }

  #gallery-info-container-arts-cellphone {
    max-width: 98vw;
    font-size: 13px;
  }

  #gallery-description-arts {
    max-width: 98vw;
    width: 90vw;
    height: 45vh;
    font-size: 14px;
  }

  #text-description-arts {
    width: 85vw;
    max-width: 85vw;
    font-size: 13px;
    padding: 12px;
  }
}

@media only screen and (max-width: 450px) {
  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
  }

  #gallery-description-arts {
    position: fixed;
    left: 50%;
    top: 50%;
    width: 90vw;
    height: 70vh;
    z-index: 300;
    background: rgba(0, 0, 0, 0.97);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 0;
    margin: 0;
    font-size: 13px;
    border-radius: 12px;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12);
  }

  #close-description-arts {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 310;
  }

  .close-description-image {
    cursor: pointer;
    width: 28px;
    height: 28px;
  }

  #text-description-arts {
    width: 92vw;
    max-width: 100%;
    max-height: 60vh;
    margin-top: 40px;
    overflow-y: auto;
    background: transparent;
    color: #fff;
    font-size: 12px;
    padding: 8px;
    border-radius: 8px;
    box-sizing: border-box;
    text-align: left;
    display: block;
  }

  #photos-arts {
    padding-top: 30px;
    margin-left: 8px;
    margin-right: 8px;
    gap: 12px 0;
  }

  .image-container {
    width: 100%;
    min-width: 0;
  }

  .image-gallery-arts {
    border-radius: 4px;
  }

  #center-image-arts {
    max-width: 400px;
  }
  iframe {
    max-width: 400px;
  }
}

@media only screen and (max-width: 400px) {
  #center-image-arts {
    max-width: 380px;
  }
  iframe {
    max-width: 380px;
  }
}
</style>
